import { BreakPoint, BREAKPOINT, FlexDirective } from '@angular/flex-layout';
import { Directive } from '@angular/core';

const BREAKPOINTS: BreakPoint[] = [
  {
    alias: 'gt-bsm',
    suffix: 'GtBsm',
    mediaQuery: 'screen and (min-width: 800px)'
  },
  {
    alias: 'gt-bmd',
    suffix: 'GtBmd',
    mediaQuery: 'screen and (min-width: 1025px)',
    priority: 1001
  },
  {
    alias: 'gt-blg',
    suffix: 'GtBlg',
    mediaQuery: 'screen and (min-width: 1440px)'
  },
  {
    alias: 'gt-bxl',
    suffix: 'GtBxl',
    mediaQuery: 'screen and (min-width: 1600px)'
  }
];

export const CustomBreakPointsProvider = {
  provide: BREAKPOINT,
  useValue: BREAKPOINTS,
  multi: true
};

const bsm = 'fxFlex.gt-bsm';
const bmd = 'fxFlex.gt-bmd';
const blg = 'fxFlex.gt-blg';
const bxl = 'fxFlex.gt-bxl';
@Directive({selector: `[${bsm}], [${bmd}], [${blg}], [${bxl}]`, inputs: [bsm, bmd, blg, bxl]})
export class CustomFlexDirective extends FlexDirective {
  protected inputs = [bsm, bmd, blg, bxl];
}
